export const createLessonPlanIntroSteps = [
  {
    element: '#help-tour-btn',
    intro: 'Click here to take a tour of this page.'
  },
  {
    element: '#resources-title',
    intro: 'The lesson plan generator allows you to create a differentiated weekly unit lesson plan for small group instruction. After you have grouped your students (by instructional zone or another system), come to the Create Lesson Plan page. If you still have questions on small group instruction or how to create a lesson plan, go to Demo Videos in the navigation menu to view videos that walk you through both.'
  },
  {
    element: '#lesson-plan-grade-select',
    intro: 'Select your students’ grade from the dropdown.'
  },
  {
    element: '#lesson-plan-unit-select',
    intro: 'Select the unit your students are working in. If the students in your group are working in multiple units, select a unit in the middle or the earliest unit depending on student needs.'
  },
  {
    element: '#lesson-plan-zone-select',
    intro: 'Select your students’ instructional zone from the dropdown. Find this information on the Group Summary under Current Zone.'
  },
  {
    element: '#lesson-plan-days-select',
    intro: 'Select the number of days you have available to work with the specific group of students.'
  },
  {
    element: '#getPdfButton',
    intro: 'Click the Generate Lesson button to download the PDF of the lesson plan.'
  }
];
